// import React, { useState, useEffect } from 'react';
// import { ref, push, set, onValue, off, remove } from 'firebase/database';
// import { database } from '../firebase';
// import { toast } from 'react-toastify';

// const AdminNotificationManager = () => {
//   // State for form inputs
//   const [notification, setNotification] = useState({
//     text: '',
//     type: 'info', // info, warning, alert, success
//     isActive: true,
//     startDate: new Date().toISOString().slice(0, 16),
//     endDate: ''
//   });

//   const [notifications, setNotifications] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [editingId, setEditingId] = useState(null);

//   // Fetch notifications from Firebase
//   useEffect(() => {
//     const notificationsRef = ref(database, 'school/notifications');
    
//     onValue(notificationsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const notificationsArray = Object.entries(data).map(([id, notification]) => ({
//           id,
//           ...notification
//         }));
//         setNotifications(notificationsArray);
//       } else {
//         setNotifications([]);
//       }
//     });

//     return () => off(notificationsRef);
//   }, []);

//   // Handle form input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setNotification(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Handle checkbox change
//   const handleCheckboxChange = (e) => {
//     const { name, checked } = e.target;
//     setNotification(prev => ({
//       ...prev,
//       [name]: checked
//     }));
//   };

//   // Submit notification (create or update)
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       if (!notification.text.trim()) {
//         throw new Error('Notification text is required');
//       }

//       const notificationData = {
//         text: notification.text.trim(),
//         type: notification.type,
//         isActive: notification.isActive,
//         startDate: notification.startDate,
//         endDate: notification.endDate || null,
//         createdAt: new Date().toISOString(),
//         updatedAt: new Date().toISOString()
//       };

//       if (editingId) {
//         // Update existing notification
//         const notificationRef = ref(database, `school/notifications/${editingId}`);
//         await set(notificationRef, notificationData);
//         toast.success('Notification updated successfully!');
//       } else {
//         // Create new notification
//         const notificationsRef = ref(database, 'school/notifications');
//         await push(notificationsRef, notificationData);
//         toast.success('Notification added successfully!');
//       }

//       // Reset form
//       setNotification({
//         text: '',
//         type: 'info',
//         isActive: true,
//         startDate: new Date().toISOString().slice(0, 16),
//         endDate: ''
//       });
//       setEditingId(null);
//     } catch (error) {
//       toast.error(error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Edit notification
//   const handleEdit = (notification) => {
//     setNotification({
//       text: notification.text,
//       type: notification.type,
//       isActive: notification.isActive,
//       startDate: notification.startDate ? notification.startDate.slice(0, 16) : new Date().toISOString().slice(0, 16),
//       endDate: notification.endDate ? notification.endDate.slice(0, 16) : ''
//     });
//     setEditingId(notification.id);
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   // Delete notification
//   const handleDelete = async (id) => {
//     if (window.confirm('Are you sure you want to delete this notification?')) {
//       try {
//         const notificationRef = ref(database, `school/notifications/${id}`);
//         await remove(notificationRef);
//         toast.success('Notification deleted successfully!');
//       } catch (error) {
//         toast.error('Failed to delete notification');
//       }
//     }
//   };

//   // Toggle notification status
//   const toggleStatus = async (id, currentStatus) => {
//     try {
//       const notificationRef = ref(database, `school/notifications/${id}/isActive`);
//       await set(notificationRef, !currentStatus);
//       toast.success(`Notification ${currentStatus ? 'disabled' : 'enabled'} successfully!`);
//     } catch (error) {
//       toast.error('Failed to update notification status');
//     }
//   };

//   // Styles
//   const cardStyle = {
//     backgroundColor: 'white',
//     borderRadius: '0.5rem',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     overflow: 'hidden'
//   };

//   const headerStyle = {
//     backgroundColor: '#4f46e5',
//     color: 'white',
//     padding: '1rem 1.5rem',
//     display: 'flex',
//     alignItems: 'center',
//     justifyContent: 'space-between'
//   };

//   const badgeStyle = (type) => ({
//     padding: '0.25rem 0.5rem',
//     borderRadius: '0.25rem',
//     fontSize: '0.75rem',
//     fontWeight: '600',
//     backgroundColor: 
//       type === 'info' ? '#dbeafe' :
//       type === 'warning' ? '#fef3c7' :
//       type === 'alert' ? '#fee2e2' :
//       '#dcfce7',
//     color: 
//       type === 'info' ? '#1e40af' :
//       type === 'warning' ? '#92400e' :
//       type === 'alert' ? '#b91c1c' :
//       '#166534'
//   });

//   return (
//     <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1.5rem' }}>
//       {/* Notification Form */}
//       <div style={{ ...cardStyle, marginBottom: '1.5rem' }}>
//         <div style={headerStyle}>
//           <h2 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>
//             {editingId ? 'Edit Notification' : 'Create New Notification'}
//           </h2>
//         </div>
//         <div style={{ padding: '1.5rem' }}>
//           <form onSubmit={handleSubmit}>
//             <div style={{ marginBottom: '1rem' }}>
//               <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
//                 Notification Text *
//               </label>
//               <input
//                 type="text"
//                 name="text"
//                 value={notification.text}
//                 onChange={handleChange}
//                 required
//                 style={{
//                   width: '100%',
//                   padding: '0.75rem',
//                   borderRadius: '0.375rem',
//                   border: '1px solid #d1d5db',
//                   fontSize: '1rem'
//                 }}
//                 placeholder="Enter notification message (e.g., School will be closed on Monday)"
//               />
//             </div>

//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1rem' }}>
//               <div>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
//                   Notification Type *
//                 </label>
//                 <select
//                   name="type"
//                   value={notification.type}
//                   onChange={handleChange}
//                   style={{
//                     width: '100%',
//                     padding: '0.75rem',
//                     borderRadius: '0.375rem',
//                     border: '1px solid #d1d5db',
//                     fontSize: '1rem'
//                   }}
//                 >
//                   <option value="info">Information (Blue)</option>
//                   <option value="warning">Warning (Yellow)</option>
//                   <option value="alert">Alert (Red)</option>
//                   <option value="success">Success (Green)</option>
//                 </select>
//               </div>

//               <div>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
//                   Start Date/Time *
//                 </label>
//                 <input
//                   type="datetime-local"
//                   name="startDate"
//                   value={notification.startDate}
//                   onChange={handleChange}
//                   required
//                   style={{
//                     width: '100%',
//                     padding: '0.75rem',
//                     borderRadius: '0.375rem',
//                     border: '1px solid #d1d5db',
//                     fontSize: '1rem'
//                   }}
//                 />
//               </div>

//               <div>
//                 <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
//                   End Date/Time (Optional)
//                 </label>
//                 <input
//                   type="datetime-local"
//                   name="endDate"
//                   value={notification.endDate}
//                   onChange={handleChange}
//                   style={{
//                     width: '100%',
//                     padding: '0.75rem',
//                     borderRadius: '0.375rem',
//                     border: '1px solid #d1d5db',
//                     fontSize: '1rem'
//                   }}
//                 />
//               </div>
//             </div>

//             <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
//               <input
//                 type="checkbox"
//                 id="isActive"
//                 name="isActive"
//                 checked={notification.isActive}
//                 onChange={handleCheckboxChange}
//                 style={{
//                   marginRight: '0.5rem',
//                   width: '1.25rem',
//                   height: '1.25rem'
//                 }}
//               />
//               <label htmlFor="isActive" style={{ fontWeight: '500', color: '#374151' }}>
//                 Active Notification
//               </label>
//             </div>

//             <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
//               {editingId && (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     setNotification({
//                       text: '',
//                       type: 'info',
//                       isActive: true,
//                       startDate: new Date().toISOString().slice(0, 16),
//                       endDate: ''
//                     });
//                     setEditingId(null);
//                   }}
//                   style={{
//                     padding: '0.75rem 1.5rem',
//                     borderRadius: '0.375rem',
//                     border: '1px solid #d1d5db',
//                     backgroundColor: 'white',
//                     color: '#374151',
//                     fontWeight: '600',
//                     cursor: 'pointer'
//                   }}
//                 >
//                   Cancel
//                 </button>
//               )}
//               <button
//                 type="submit"
//                 disabled={loading}
//                 style={{
//                   padding: '0.75rem 1.5rem',
//                   borderRadius: '0.375rem',
//                   border: 'none',
//                   backgroundColor: '#4f46e5',
//                   color: 'white',
//                   fontWeight: '600',
//                   cursor: loading ? 'not-allowed' : 'pointer',
//                   opacity: loading ? 0.7 : 1
//                 }}
//               >
//                 {loading ? (
//                   <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
//                     <svg
//                       style={{
//                         animation: 'spin 1s linear infinite',
//                         marginRight: '0.5rem',
//                         width: '1.25rem',
//                         height: '1.25rem'
//                       }}
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                       <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                     </svg>
//                     {editingId ? 'Updating...' : 'Creating...'}
//                   </span>
//                 ) : (
//                   <span>{editingId ? 'Update Notification' : 'Create Notification'}</span>
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>

//       {/* Notifications List */}
//       <div style={cardStyle}>
//         <div style={headerStyle}>
//           <h2 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>Active Notifications</h2>
//         </div>
//         <div style={{ padding: '1.5rem' }}>
//           {notifications.length > 0 ? (
//             <div style={{ overflowX: 'auto' }}>
//               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                 <thead>
//                   <tr style={{ backgroundColor: '#f3f4f6', textAlign: 'left' }}>
//                     <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Notification</th>
//                     <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Type</th>
//                     <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Status</th>
//                     <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Date Range</th>
//                     <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {notifications.map((notif) => (
//                     <tr key={notif.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
//                       <td style={{ padding: '1rem', verticalAlign: 'top' }}>
//                         <div style={{ fontWeight: '500', marginBottom: '0.25rem' }}>{notif.text}</div>
//                         <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
//                           Created: {new Date(notif.createdAt).toLocaleString()}
//                         </div>
//                       </td>
//                       <td style={{ padding: '1rem', verticalAlign: 'top' }}>
//                         <span style={badgeStyle(notif.type)}>
//                           {notif.type.charAt(0).toUpperCase() + notif.type.slice(1)}
//                         </span>
//                       </td>
//                       <td style={{ padding: '1rem', verticalAlign: 'top' }}>
//                         <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
//                           <input
//                             type="checkbox"
//                             checked={notif.isActive}
//                             onChange={() => toggleStatus(notif.id, notif.isActive)}
//                             style={{
//                               marginRight: '0.5rem',
//                               width: '1.25rem',
//                               height: '1.25rem'
//                             }}
//                           />
//                           <span style={{ color: notif.isActive ? '#10b981' : '#ef4444', fontWeight: '500' }}>
//                             {notif.isActive ? 'Active' : 'Inactive'}
//                           </span>
//                         </label>
//                       </td>
//                       <td style={{ padding: '1rem', verticalAlign: 'top' }}>
//                         <div style={{ marginBottom: '0.25rem' }}>
//                           <strong>Starts:</strong> {new Date(notif.startDate).toLocaleString()}
//                         </div>
//                         {notif.endDate && (
//                           <div>
//                             <strong>Ends:</strong> {new Date(notif.endDate).toLocaleString()}
//                           </div>
//                         )}
//                       </td>
//                       <td style={{ padding: '1rem', verticalAlign: 'top' }}>
//                         <div style={{ display: 'flex', gap: '0.5rem' }}>
//                           <button
//                             onClick={() => handleEdit(notif)}
//                             style={{
//                               padding: '0.5rem',
//                               borderRadius: '0.25rem',
//                               backgroundColor: '#3b82f6',
//                               color: 'white',
//                               border: 'none',
//                               cursor: 'pointer'
//                             }}
//                             title="Edit"
//                           >
//                             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
//                             </svg>
//                           </button>
//                           <button
//                             onClick={() => handleDelete(notif.id)}
//                             style={{
//                               padding: '0.5rem',
//                               borderRadius: '0.25rem',
//                               backgroundColor: '#ef4444',
//                               color: 'white',
//                               border: 'none',
//                               cursor: 'pointer'
//                             }}
//                             title="Delete"
//                           >
//                             <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
//                               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
//                             </svg>
//                           </button>
//                         </div>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           ) : (
//             <div style={{ textAlign: 'center', padding: '2rem' }}>
//               <svg
//                 style={{ width: '3rem', height: '3rem', margin: '0 auto 1rem', color: '#9ca3af' }}
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//               <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>
//                 No Notifications Found
//               </h3>
//               <p style={{ color: '#6b7280' }}>Create your first notification using the form above</p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Preview Section */}
//       <div style={{ ...cardStyle, marginTop: '1.5rem' }}>
//         <div style={headerStyle}>
//           <h2 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>Notification Preview</h2>
//         </div>
//         <div style={{ padding: '1.5rem' }}>
//           <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#374151', marginBottom: '1rem' }}>
//             How the notification will appear on your website:
//           </h3>
          
//           <div style={{ 
//             padding: '1rem',
//             border: '1px dashed #d1d5db',
//             borderRadius: '0.375rem',
//             backgroundColor: '#f9fafb'
//           }}>
//             {notifications.filter(n => n.isActive).length > 0 ? (
//               <div style={{ 
//                 backgroundColor: '#f3f4f6',
//                 padding: '0.75rem',
//                 borderRadius: '0.25rem',
//                 position: 'relative',
//                 overflow: 'hidden'
//               }}>
//                 <div style={{
//                   position: 'absolute',
//                   top: 0,
//                   left: 0,
//                   bottom: 0,
//                   width: '4px',
//                   backgroundColor: 
//                     notifications[0].type === 'info' ? '#3b82f6' :
//                     notifications[0].type === 'warning' ? '#f59e0b' :
//                     notifications[0].type === 'alert' ? '#ef4444' :
//                     '#10b981'
//                 }}></div>
//                 <div style={{ 
//                   display: 'flex',
//                   alignItems: 'center',
//                   paddingLeft: '1rem'
//                 }}>
//                   <svg
//                     style={{
//                       width: '1.25rem',
//                       height: '1.25rem',
//                       marginRight: '0.75rem',
//                       color: 
//                         notifications[0].type === 'info' ? '#3b82f6' :
//                         notifications[0].type === 'warning' ? '#f59e0b' :
//                         notifications[0].type === 'alert' ? '#ef4444' :
//                         '#10b981'
//                     }}
//                     fill="none"
//                     stroke="currentColor"
//                     viewBox="0 0 24 24"
//                   >
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                   </svg>
//                   <div style={{ 
//                     whiteSpace: 'nowrap',
//                     animation: 'scroll 15s linear infinite',
//                     fontSize: '1rem',
//                     fontWeight: '500'
//                   }}>
//                     {notifications[0].text}
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div style={{ color: '#6b7280', fontStyle: 'italic' }}>
//                 No active notifications to display
//               </div>
//             )}
//           </div>
//         </div>
//       </div>

//       <style>{`
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//         @keyframes scroll {
//           0% { transform: translateX(100%); }
//           100% { transform: translateX(-100%); }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default AdminNotificationManager;




import React, { useState, useEffect } from 'react';
import { ref, push, set, onValue, off, remove } from 'firebase/database';
import { database } from '../firebase';
import { toast } from 'react-toastify';

const AdminNotificationManager = () => {
  // State for form inputs
  const [notification, setNotification] = useState({
    text: '',
    type: 'info', // info, warning, alert, success
    isActive: true,
    startDate: new Date().toISOString().slice(0, 16),
    endDate: ''
  });

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [previewIndex, setPreviewIndex] = useState(0);

  // Fetch notifications from Firebase
  useEffect(() => {
    const notificationsRef = ref(database, 'school/notifications');
    
    onValue(notificationsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const notificationsArray = Object.entries(data).map(([id, notification]) => ({
          id,
          ...notification
        }));
        setNotifications(notificationsArray);
      } else {
        setNotifications([]);
      }
    });

    return () => off(notificationsRef);
  }, []);

  // Filter active notifications
  const activeNotifications = notifications.filter(n => n.isActive);

  // Cycle through notifications in preview
  useEffect(() => {
    if (activeNotifications.length <= 1) return;

    const timer = setInterval(() => {
      setPreviewIndex(prev => (prev >= activeNotifications.length - 1 ? 0 : prev + 1));
    }, 3000); // Change every 3 seconds

    return () => clearInterval(timer);
  }, [activeNotifications.length]);

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNotification(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setNotification(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  // Submit notification (create or update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!notification.text.trim()) {
        throw new Error('Notification text is required');
      }

      const notificationData = {
        text: notification.text.trim(),
        type: notification.type,
        isActive: notification.isActive,
        startDate: notification.startDate,
        endDate: notification.endDate || null,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };

      if (editingId) {
        // Update existing notification
        const notificationRef = ref(database, `school/notifications/${editingId}`);
        await set(notificationRef, notificationData);
        toast.success('Notification updated successfully!');
      } else {
        // Create new notification
        const notificationsRef = ref(database, 'school/notifications');
        await push(notificationsRef, notificationData);
        toast.success('Notification added successfully!');
      }

      // Reset form
      setNotification({
        text: '',
        type: 'info',
        isActive: true,
        startDate: new Date().toISOString().slice(0, 16),
        endDate: ''
      });
      setEditingId(null);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  // Edit notification
  const handleEdit = (notification) => {
    setNotification({
      text: notification.text,
      type: notification.type,
      isActive: notification.isActive,
      startDate: notification.startDate ? notification.startDate.slice(0, 16) : new Date().toISOString().slice(0, 16),
      endDate: notification.endDate ? notification.endDate.slice(0, 16) : ''
    });
    setEditingId(notification.id);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Delete notification
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this notification?')) {
      try {
        const notificationRef = ref(database, `school/notifications/${id}`);
        await remove(notificationRef);
        toast.success('Notification deleted successfully!');
      } catch (error) {
        toast.error('Failed to delete notification');
      }
    }
  };

  // Toggle notification status
  const toggleStatus = async (id, currentStatus) => {
    try {
      const notificationRef = ref(database, `school/notifications/${id}/isActive`);
      await set(notificationRef, !currentStatus);
      toast.success(`Notification ${currentStatus ? 'disabled' : 'enabled'} successfully!`);
    } catch (error) {
      toast.error('Failed to update notification status');
    }
  };

  // Styles
  const cardStyle = {
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
    overflow: 'hidden'
  };

  const headerStyle = {
    backgroundColor: '#4f46e5',
    color: 'white',
    padding: '1rem 1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  };

  const badgeStyle = (type) => ({
    padding: '0.25rem 0.5rem',
    borderRadius: '0.25rem',
    fontSize: '0.75rem',
    fontWeight: '600',
    backgroundColor: 
      type === 'info' ? '#dbeafe' :
      type === 'warning' ? '#fef3c7' :
      type === 'alert' ? '#fee2e2' :
      '#dcfce7',
    color: 
      type === 'info' ? '#1e40af' :
      type === 'warning' ? '#92400e' :
      type === 'alert' ? '#b91c1c' :
      '#166534'
  });

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '1.5rem' }}>
      {/* Notification Form */}
      <div style={{ ...cardStyle, marginBottom: '1.5rem' }}>
        <div style={headerStyle}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>
            {editingId ? 'Edit Notification' : 'Create New Notification'}
          </h2>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '1rem' }}>
              <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
                Notification Text *
              </label>
              <input
                type="text"
                name="text"
                value={notification.text}
                onChange={handleChange}
                required
                style={{
                  width: '100%',
                  padding: '0.75rem',
                  borderRadius: '0.375rem',
                  border: '1px solid #d1d5db',
                  fontSize: '1rem'
                }}
                placeholder="Enter notification message (e.g., School will be closed on Monday)"
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', marginBottom: '1rem' }}>
              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
                  Notification Type *
                </label>
                <select
                  name="type"
                  value={notification.type}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '0.375rem',
                    border: '1px solid #d1d5db',
                    fontSize: '1rem'
                  }}
                >
                  <option value="info">Information (Blue)</option>
                  <option value="warning">Warning (Yellow)</option>
                  <option value="alert">Alert (Red)</option>
                  <option value="success">Success (Green)</option>
                </select>
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
                  Start Date/Time *
                </label>
                <input
                  type="datetime-local"
                  name="startDate"
                  value={notification.startDate}
                  onChange={handleChange}
                  required
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '0.375rem',
                    border: '1px solid #d1d5db',
                    fontSize: '1rem'
                  }}
                />
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: '500', color: '#374151' }}>
                  End Date/Time (Optional)
                </label>
                <input
                  type="datetime-local"
                  name="endDate"
                  value={notification.endDate}
                  onChange={handleChange}
                  style={{
                    width: '100%',
                    padding: '0.75rem',
                    borderRadius: '0.375rem',
                    border: '1px solid #d1d5db',
                    fontSize: '1rem'
                  }}
                />
              </div>
            </div>

            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1.5rem' }}>
              <input
                type="checkbox"
                id="isActive"
                name="isActive"
                checked={notification.isActive}
                onChange={handleCheckboxChange}
                style={{
                  marginRight: '0.5rem',
                  width: '1.25rem',
                  height: '1.25rem'
                }}
              />
              <label htmlFor="isActive" style={{ fontWeight: '500', color: '#374151' }}>
                Active Notification
              </label>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '1rem' }}>
              {editingId && (
                <button
                  type="button"
                  onClick={() => {
                    setNotification({
                      text: '',
                      type: 'info',
                      isActive: true,
                      startDate: new Date().toISOString().slice(0, 16),
                      endDate: ''
                    });
                    setEditingId(null);
                  }}
                  style={{
                    padding: '0.75rem 1.5rem',
                    borderRadius: '0.375rem',
                    border: '1px solid #d1d5db',
                    backgroundColor: 'white',
                    color: '#374151',
                    fontWeight: '600',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>
              )}
              <button
                type="submit"
                disabled={loading}
                style={{
                  padding: '0.75rem 1.5rem',
                  borderRadius: '0.375rem',
                  border: 'none',
                  backgroundColor: '#4f46e5',
                  color: 'white',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  opacity: loading ? 0.7 : 1
                }}
              >
                {loading ? (
                  <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <svg
                      style={{
                        animation: 'spin 1s linear infinite',
                        marginRight: '0.5rem',
                        width: '1.25rem',
                        height: '1.25rem'
                      }}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle style={{ opacity: 0.25 }} cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path style={{ opacity: 0.75 }} fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {editingId ? 'Updating...' : 'Creating...'}
                  </span>
                ) : (
                  <span>{editingId ? 'Update Notification' : 'Create Notification'}</span>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>

      {/* Notifications List */}
      <div style={cardStyle}>
        <div style={headerStyle}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>All Notifications</h2>
        </div>
        <div style={{ padding: '1.5rem' }}>
          {notifications.length > 0 ? (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                  <tr style={{ backgroundColor: '#f3f4f6', textAlign: 'left' }}>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Notification</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Type</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Status</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Date Range</th>
                    <th style={{ padding: '0.75rem 1rem', fontWeight: '600', color: '#374151' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {notifications.map((notif) => (
                    <tr key={notif.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                      <td style={{ padding: '1rem', verticalAlign: 'top' }}>
                        <div style={{ fontWeight: '500', marginBottom: '0.25rem' }}>{notif.text}</div>
                        <div style={{ fontSize: '0.75rem', color: '#6b7280' }}>
                          Created: {new Date(notif.createdAt).toLocaleString()}
                        </div>
                      </td>
                      <td style={{ padding: '1rem', verticalAlign: 'top' }}>
                        <span style={badgeStyle(notif.type)}>
                          {notif.type.charAt(0).toUpperCase() + notif.type.slice(1)}
                        </span>
                      </td>
                      <td style={{ padding: '1rem', verticalAlign: 'top' }}>
                        <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
                          <input
                            type="checkbox"
                            checked={notif.isActive}
                            onChange={() => toggleStatus(notif.id, notif.isActive)}
                            style={{
                              marginRight: '0.5rem',
                              width: '1.25rem',
                              height: '1.25rem'
                            }}
                          />
                          <span style={{ color: notif.isActive ? '#10b981' : '#ef4444', fontWeight: '500' }}>
                            {notif.isActive ? 'Active' : 'Inactive'}
                          </span>
                        </label>
                      </td>
                      <td style={{ padding: '1rem', verticalAlign: 'top' }}>
                        <div style={{ marginBottom: '0.25rem' }}>
                          <strong>Starts:</strong> {new Date(notif.startDate).toLocaleString()}
                        </div>
                        {notif.endDate && (
                          <div>
                            <strong>Ends:</strong> {new Date(notif.endDate).toLocaleString()}
                          </div>
                        )}
                      </td>
                      <td style={{ padding: '1rem', verticalAlign: 'top' }}>
                        <div style={{ display: 'flex', gap: '0.5rem' }}>
                          <button
                            onClick={() => handleEdit(notif)}
                            style={{
                              padding: '0.5rem',
                              borderRadius: '0.25rem',
                              backgroundColor: '#3b82f6',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer'
                            }}
                            title="Edit"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                          </button>
                          <button
                            onClick={() => handleDelete(notif.id)}
                            style={{
                              padding: '0.5rem',
                              borderRadius: '0.25rem',
                              backgroundColor: '#ef4444',
                              color: 'white',
                              border: 'none',
                              cursor: 'pointer'
                            }}
                            title="Delete"
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ textAlign: 'center', padding: '2rem' }}>
              <svg
                style={{ width: '3rem', height: '3rem', margin: '0 auto 1rem', color: '#9ca3af' }}
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <h3 style={{ fontSize: '1.125rem', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>
                No Notifications Found
              </h3>
              <p style={{ color: '#6b7280' }}>Create your first notification using the form above</p>
            </div>
          )}
        </div>
      </div>

      {/* Preview Section */}
      <div style={{ ...cardStyle, marginTop: '1.5rem' }}>
        <div style={headerStyle}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: '600', margin: 0 }}>Live Preview</h2>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <h3 style={{ fontSize: '1rem', fontWeight: '600', color: '#374151', marginBottom: '1rem' }}>
            How notifications will appear on your website:
          </h3>
          
          <div style={{ 
            padding: '1rem',
            border: '1px dashed #d1d5db',
            borderRadius: '0.375rem',
            backgroundColor: '#f9fafb'
          }}>
            {activeNotifications.length > 0 ? (
              <>
                {/* Preview Container */}
                <div style={{ 
                  backgroundColor: '#f3f4f6',
                  padding: '0.75rem',
                  borderRadius: '0.25rem',
                  position: 'relative',
                  overflow: 'hidden',
                  minHeight: '60px'
                }}>
                  {/* Left border colored by notification type */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    width: '4px',
                    backgroundColor: 
                      activeNotifications[previewIndex].type === 'info' ? '#3b82f6' :
                      activeNotifications[previewIndex].type === 'warning' ? '#f59e0b' :
                      activeNotifications[previewIndex].type === 'alert' ? '#ef4444' :
                      '#10b981'
                  }}></div>
                  
                  {/* Notification Content */}
                  <div style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    paddingLeft: '1rem'
                  }}>
                    {/* Icon */}
                    <svg
                      style={{
                        width: '1.25rem',
                        height: '1.25rem',
                        marginRight: '0.75rem',
                        color: 
                          activeNotifications[previewIndex].type === 'info' ? '#3b82f6' :
                          activeNotifications[previewIndex].type === 'warning' ? '#f59e0b' :
                          activeNotifications[previewIndex].type === 'alert' ? '#ef4444' :
                          '#10b981',
                        flexShrink: 0
                      }}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      {activeNotifications[previewIndex].type === 'info' && (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      )}
                      {activeNotifications[previewIndex].type === 'warning' && (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                      )}
                      {activeNotifications[previewIndex].type === 'alert' && (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      )}
                      {activeNotifications[previewIndex].type === 'success' && (
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      )}
                    </svg>
                    
                    {/* Scrolling Text */}
                    <div style={{ 
                      whiteSpace: 'nowrap',
                      animation: 'scroll 15s linear infinite',
                      fontSize: '1rem',
                      fontWeight: '500',
                      flexGrow: 1
                    }}>
                      {activeNotifications[previewIndex].text}
                    </div>
                    
                    {/* Notification Counter */}
                    {activeNotifications.length > 1 && (
                      <div style={{
                        marginLeft: '1rem',
                        padding: '0.25rem 0.5rem',
                        borderRadius: '9999px',
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        fontSize: '0.75rem',
                        fontWeight: '600',
                        flexShrink: 0
                      }}>
                        {previewIndex + 1}/{activeNotifications.length}
                      </div>
                    )}
                  </div>
                </div>

                {/* Notification List (for admin reference) */}
                <div style={{ marginTop: '1rem' }}>
                  <h4 style={{ fontSize: '0.875rem', fontWeight: '600', color: '#374151', marginBottom: '0.5rem' }}>
                    All Active Notifications:
                  </h4>
                  <ul style={{ listStyle: 'none', padding: 0 }}>
                    {activeNotifications.map((notif, index) => (
                      <li 
                        key={notif.id} 
                        style={{ 
                          padding: '0.5rem',
                          backgroundColor: index === previewIndex ? '#e5e7eb' : 'transparent',
                          borderRadius: '0.25rem',
                          cursor: 'pointer',
                          display: 'flex',
                          alignItems: 'center'
                        }}
                        onClick={() => setPreviewIndex(index)}
                      >
                        <span style={badgeStyle(notif.type)}>
                          {notif.type.charAt(0).toUpperCase() + notif.type.slice(1)}
                        </span>
                        <span style={{ marginLeft: '0.5rem', flexGrow: 1 }}>{notif.text}</span>
                        {index === previewIndex && (
                          <span style={{ color: '#4f46e5', fontWeight: '600' }}>Currently Showing</span>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            ) : (
              <div style={{ color: '#6b7280', fontStyle: 'italic' }}>
                No active notifications to display
              </div>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        @keyframes scroll {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </div>
  );
};

export default AdminNotificationManager;